import { Swiper } from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

export const Home = {
  init() {
    if (document.querySelector('.p-home-sliders__top')) {
      new Swiper('.p-home-sliders__top .swiper', {
        modules: [Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 0,
        },
        speed: 7000,
        on: {
          resize: (swiper) => {
            swiper.updateSize();
          },
        },
      });
    }
    if (document.querySelector('.p-home-sliders__bottom')) {
      new Swiper('.p-home-sliders__bottom .swiper', {
        modules: [Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 0,
          reverseDirection: true,
        },
        centeredSlides: true,
        initialSlide: 7,
        speed: 7000,
        on: {
          resize: (swiper) => {
            swiper.updateSize();
          },
        },
      });
    }
    if (document.querySelector('.p-home-news__list .swiper')) {
      const swiperEl = document.querySelector('.p-home-news__list .swiper');
      const links = document.querySelectorAll('.p-home-news__list .p-home-news__link');
      let maxHeight = 0;
      links.forEach((link) => {
        if (maxHeight < link.clientHeight) {
          maxHeight = link.clientHeight;
        }
      });
      swiperEl.style.height = maxHeight + 'px';

      new Swiper('.p-home-news__list .swiper', {
        modules: [Autoplay],
        direction: 'vertical',
        slidesPerView: 'auto',
        loop: true,
        allowTouchMove: false,
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        on: {
          resize: (swiper) => {
            maxHeight = 0;
            links.forEach((link) => {
              if (maxHeight < link.clientHeight) {
                maxHeight = link.clientHeight;
              }
            });
            swiperEl.style.height = maxHeight + 'px';
          },
        },
      });
    }
  },
};
